import type { ComponentType } from 'react';

import { useFieldToTextField } from 'formik-material-ui'
import type { TextFieldProps } from 'formik-material-ui'

import { TextField as TextFieldStyled } from '../../elements/TextField/'

export interface IFormTextFieldProps extends TextFieldProps {
  /** Unique identifier for analytics tracking of text form field interactions. */
  analyticsId?: string
}

// Pass Formik props to the styled TextField
// Creates a styled text field with Formik & Material UI props
export const TextField: ComponentType<IFormTextFieldProps> = ({
  children,
  analyticsId,
  ...props
}: IFormTextFieldProps) => (
  <TextFieldStyled
    {...useFieldToTextField(props)}
    variant='standard'
    analyticsId={analyticsId}
  >
    {children}
  </TextFieldStyled>
)

TextField.displayName = 'Form.TextField'
TextField.defaultProps = {
  fullWidth: true,
}
